import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { groupApi } from '@formosa/shared/api/im';
import { getMemberId } from '@formosa/shared/auth/tokenStorage';
import GroupMemberPicker from '../../components/chat/GroupMemberPicker';
import '../../styles/chat.css';

/** /chat/groups/new — create GROUP with multi-select members */
export default function CreateGroupPage() {
  const navigate = useNavigate();
  const myId = getMemberId();
  const [title, setTitle] = useState('');
  const [selected, setSelected] = useState([]);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const submit = async () => {
    const name = title.trim();
    if (!name) {
      setError('請輸入群組名稱');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      const conv = await groupApi.create({
        title: name,
        memberIds: selected.map((s) => s.memberId),
      });
      const cid = conv?.conversationId || conv?.id;
      if (cid) navigate(`/chat/${cid}`);
      else navigate('/chat/groups');
    } catch (err) {
      setError(err?.message || '建立失敗（可能被封鎖／隱私拒絕）');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="chat-social-page">
      <header className="chat-social-page__header">
        <Link to="/chat/groups" className="chat-link-btn">
          ← 群組
        </Link>
        <h1>建立群組</h1>
      </header>

      <div className="group-create-form">
        <label className="group-create-form__field">
          <span>群組名稱</span>
          <input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            maxLength={128}
            placeholder="例如：週末出遊"
            autoComplete="off"
            onKeyDown={(e) => {
              if (e.key === 'Enter') e.preventDefault();
            }}
          />
        </label>

        <h2 className="group-create-form__section">選擇成員</h2>
        <GroupMemberPicker
          value={selected}
          onChange={setSelected}
          excludeIds={myId != null ? [myId] : []}
        />

        {error ? <p className="chat-social-page__error">{error}</p> : null}

        <button
          type="button"
          className="group-create-form__submit"
          disabled={submitting}
          onClick={submit}
        >
          {submitting ? '建立中…' : `建立（已選 ${selected.length} 人）`}
        </button>
      </div>
    </div>
  );
}
